import { defineMessages } from 'react-intl';

export default defineMessages({
  orderDate: {
    id: 'account.orderHistory.orderDate',
    defaultMessage: 'Date',
  },
  orderProducts: {
    id: 'account.orderHistory.orderProducts',
    defaultMessage: 'Products',
  },
  orderReference: {
    id: 'account.orderHistory.orderReference',
    defaultMessage: 'Reference',
  },
  orderTotal: {
    id: 'account.orderHistory.orderTotal',
    defaultMessage: 'Order Total',
  },
  orderViewDetails: {
    id: 'account.orderHistory.orderViewDetails',
    defaultMessage: 'View details',
  },
  returnRequest: {
    id: 'account.orderHistory.returnRequest',
    defaultMessage: 'Return Request',
  },
});
